<script>
import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";
import locationLogs from "./locationLogs/index.vue";
import custodyTransferLogs from "./custodyTransferLogs/index.vue";
export default {
  page: {
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    locationLogs,
    custodyTransferLogs
  },
  data() {
    return {
      fixed_asset_product:{}
    };
  },
  methods: {
    getFixedAsseById(id){
      this.http.get('fixed-assets/fixed-asset-product/'+id).then((res)=>{
        if(res.status)
        this.fixed_asset_product=res.data
      })

    }
  },
  created() { 
    this.getFixedAsseById(this.$route.params.fixed_asset_product_id)
  },
};
</script>

<template>
  <Layout>
       <div class="row">
      <div class="row align-items-center">
        <div class="d-flex align-items-center  mb-4">
          <router-link :to="{name:'fixed-assets'}"  class="click ">
            <h4 class="m-0">{{ $t("fixed_assets.title") }}</h4>
          </router-link>
          <div class="mx-2">\</div>
          <div>
            <router-link :to="{name:'fixed-assets-profile', params:{id:this.$route.params.id} }" class="click " >

            <h5 class="m-0">{{
              $i18n.locale == "ar"
                ? fixed_asset_product?.fixed_asset?.name
                : fixed_asset_product?.fixed_asset?.name_en +' - '+fixed_asset_product.serial_no 
            }}</h5>
            
            </router-link>
          </div>
          <div class="mx-2">\</div>
          <div>
            <h5 class="m-0">{{$t("fixed_assets.transfers")}}</h5>
            
          </div>
        </div>
      </div>
    </div>
    <!-- start personal informations -->
    <b-tabs :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'" justified nav-class="nav-tabs-custom"
      content-class="p-3 text-muted">
      <!-- start departments -->
      
      <b-tab active> 
        <template v-slot:title>
          <span :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'" class="d-none d-sm-inline-block">{{
            $t("fixed_assets.custody_transfer_logs") }}</span>
        </template>
        <custodyTransferLogs />
      </b-tab>
      <b-tab>
        <template v-slot:title>
          <span :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'" class="d-none d-sm-inline-block">{{
            $t("fixed_assets.location_logs") }}</span>
        </template>
        <locationLogs />
      </b-tab>
    </b-tabs>

    <!-- end personal informations -->
  </Layout>
</template>
<style scoped>

.click{
  cursor: pointer;
}
</style>
